import React from 'react';
import { useTranslation } from 'react-i18next';
const Loading = (props) => {
  const { t } = useTranslation(['common']);
  const { message = t('loading') } = props;
  return <h3>{message}</h3>;
};

export default Loading;
